import { Component, OnInit } from '@angular/core';
import { NaviService } from '../../services/navi.service';

import { ActivatedRoute, ParamMap, Params } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-group-details-nav',
  templateUrl: './group-details-nav.component.html',
  styleUrls: ['./group-details-nav.component.css']
})
export class GroupDetailsNavComponent implements OnInit {
  public overview: String = '/managing-groups/';
  public member: String = '/managing-groups/';
  public collaborator: String = '/managing-groups/';
  public statistics: String = '/managing-groups/';
  public messages: String = '/managing-groups/';

  constructor(private naviService: NaviService, private route: ActivatedRoute, private location: Location) { }

  ngOnInit() {
    this.route.paramMap.switchMap((params: ParamMap) => {
      const studyId = params.get('id');
      this.overview = 'hcp/managing-groups/' + studyId + '/detail';
      this.member = 'hcp/managing-groups/' + studyId + '/members';
      this.collaborator = 'hcp/managing-groups/' + studyId + '/collaborators';
      this.statistics = 'hcp/managing-groups/' + studyId + '/statistics';
      this.messages = 'hcp/managing-groups/' + studyId + '/messages';
      return null;
    });

    this.route.params.subscribe((params: Params) => {
      const studyId = params['id'];
      this.overview = 'hcp/managing-groups/' + studyId + '/detail';
      this.member = 'hcp/managing-groups/' + studyId + '/members';
      this.collaborator = 'hcp/managing-groups/' + studyId + '/collaborators';
      this.statistics = 'hcp/managing-groups/' + studyId + '/statistics';
      this.messages = 'hcp/managing-groups/' + studyId + '/messages';
    });
  }

  public navigate(url: String): void {
    this.naviService.navigateToUrl(url, 'mygroups');
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/group-details-nav/group-details-nav.component.ts